import { type FunctionComponent, useEffect } from 'react';
import classNames from 'classnames';

import { trackEvent } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link';
import copy from '../helpers/copy';

import styles from './IphoneSharedLinkTextingWidget.scss';

type Props = {
    widgetClassNames?: {
        inner?: string;
        inputWrapper?: string;
        button?: string;
    };
};

export const IphoneSharedLinkTextingWidget: FunctionComponent<Props> = ({
    widgetClassNames = {},
}) => {
    const { inner, inputWrapper, button } = widgetClassNames;
    const successText = 'message sent';

    useEffect(() => {
        // Third party service LinkTexting adds '_0' to the button id, therefore selecting ids starting with 'sendButton_linkTexting'
        const submitButton = document.querySelector('[id^="sendButton_linkTexting"]');
        if (submitButton) {
            const callback = (mutations: MutationRecord[]): void => {
                for (const mutation of mutations) {
                    if (mutation.type === 'childList') {
                        const textNode = mutation.addedNodes[0];
                        const wasSmsSent = (textNode as Text)?.data?.toLowerCase() === successText;

                        if (wasSmsSent) {
                            trackEvent({
                                label: 'app landing page',
                                action: 'app download sms submitted',
                                category: 'promo interaction',
                            });

                            break;
                        }
                    }
                }
            };

            const config = {
                childList: true,
                subtree: false,
            };

            const observer = new MutationObserver(callback);
            observer.observe(submitButton, config);

            return function disconnectObserver() {
                observer.disconnect();
            };
        }

        return () => {};
    }, [successText]);

    return (
        <div className="promptWrapper">
            <div className="linkTextingWidget">
                <div className={classNames('linkTextingInner', inner)}>
                    <div className={classNames(inputWrapper, styles.inputWrapper)}>
                        <div className="linkTextingInputWrapper">
                            <input
                                type="tel"
                                id="numberToText_linkTexting"
                                className={`linkTextingInput ${styles.input}`}
                            />
                        </div>
                        <div
                            className={`linkTextingError ${styles.error}`}
                            id="linkTextingError"
                            style={{ display: 'none' }}
                        />
                    </div>
                    <Link
                        className={classNames('linkTextingButton', styles.button, button)}
                        id="sendButton_linkTexting"
                        href=""
                    >
                        {copy.sendSms}
                    </Link>
                    <input
                        type="hidden"
                        className="linkID"
                        value="74193baa-8c7f-4b3f-bc66-245e4f8522a3"
                    />
                </div>
            </div>
        </div>
    );
};
